export interface LineItemData {
  alternate: string | null;
  category: string | null;
  color?: string | null;
  created_at: string;
  created_by: string;
  deleted_at: string | null;
  equip_uc: number | null;
  estimate: string;
  estimate_labor_crew?: string | null;
  estimate_system: string | null;
  estimate_use_groups: { [key: string]: number };
  extras: Record<string, string>;
  gcgr_line_item: string | null;
  gcgr_total_uc: number | null;
  id: string;
  import_batch: string | null;
  labor_rate: number | null;
  labor_uc: number | null;
  material_uc: number | null;
  mf: Record<string, string>;
  name: string;
  notes: string | null;
  order: string;
  other_uc: number | null;
  parent?: string | null;
  prod_rate: number | null;
  product: string | null;
  product_original: string | null;
  quantity: number;
  quantity_formula: any; //string | null;
  selected_traditional_assembly: boolean;
  sub_uc: number | null;
  total_cost: number;
  total_cost_text: string | null;
  total_uc: number | null;
  type: string | null;
  uf: Record<string, string>;
  uom: string;
  updated_at: string;
  updated_by: string;
  updated_by_at: string;
}

export const excludedKeys = new Set<keyof LineItemData>([
  "color",
  "estimate_use_groups",
  "deleted_at",
  "extras",
  "gcgr_line_item",
  "gcgr_total_uc",
  "product_original",
  "quantity_formula",
  "selected_traditional_assembly",
  "total_cost_text",
  "total_cost",
  "updated_by_at",
  "created_by",
  "updated_by",
  "estimate",
  "mf",
  "uf",
]);

export interface LineItem extends Omit<LineItemData, keyof typeof excludedKeys> {
  total: number | string;
  markup_allocation: number;
  total_plus_markup: number;
  alternateId?: string;
  alternate_code?: string;
  alternate_desc?: string;
  alternateStatus?: string;
  accepted?: boolean;
  baseBid?: boolean;
  lmseo_prorated: boolean;
  labor_rate_prorated: boolean;
  use_group: string;
  floor_group: string;
  [key: string]: any; // Allows dynamic keys like mf1, mf2, uf1, uf2
}
